/**
 * pll-tab-bar.js
 * Shared sticky behaviour + scroll hints for ALL tab bars on the site.
 * Works on any element with [data-pll-tab-bar].
 *
 * Expected markup:
 *   <div class="pll-tb-wrap" data-pll-tab-bar>
 *     <div class="pll-tb-bar">...tabs...</div>
 *     <!-- arrow buttons injected here by this script -->
 *   </div>
 */
(function () {
  'use strict';

  function getNavH() {
    var el = document.querySelector('.section-header');
    return el ? Math.max(el.getBoundingClientRect().bottom, 0) : 44;
  }

  function initTabBar(wrap) {
    var bar = wrap.querySelector('.pll-tb-bar');
    if (!bar) return;

    /* ---- inject arrow buttons ---- */
    var btnL = document.createElement('button');
    btnL.className = 'pll-tb-hint pll-tb-hint--l';
    btnL.setAttribute('aria-label', 'Scroll left');
    btnL.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';
    var btnR = document.createElement('button');
    btnR.className = 'pll-tb-hint pll-tb-hint--r';
    btnR.setAttribute('aria-label', 'Scroll right');
    btnR.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>';
    wrap.appendChild(btnL);
    wrap.appendChild(btnR);
    btnL.addEventListener('click', function () { bar.scrollBy({ left: -160, behavior: 'smooth' }); });
    btnR.addEventListener('click', function () { bar.scrollBy({ left: 160, behavior: 'smooth' }); });

    /* ---- scroll hints ---- */
    function updateHints() {
      wrap.classList.toggle('pll-tb--has-l', bar.scrollLeft > 2);
      wrap.classList.toggle('pll-tb--at-end', bar.scrollLeft + bar.clientWidth >= bar.scrollWidth - 4);
    }
    bar.addEventListener('scroll', updateHints, { passive: true });
    window.addEventListener('resize', updateHints, { passive: true });
    setTimeout(updateHints, 200);

    /* ---- sticky behaviour ---- */
    var fixed = false;
    var placeholder = null;
    var origTop = 0;
    var alignRaf = null;
    var alignUntil = 0;

    function keepAligned() {
      alignRaf = null;
      if (!fixed) return;
      wrap.style.top = getNavH() + 'px';
      if (Date.now() < alignUntil) alignRaf = requestAnimationFrame(keepAligned);
    }
    function startAlign() {
      alignUntil = Date.now() + 300;
      if (!alignRaf) alignRaf = requestAnimationFrame(keepAligned);
    }
    function makeFixed() {
      if (fixed) return;
      fixed = true;
      var bh = wrap.offsetHeight;
      if (!placeholder) {
        placeholder = document.createElement('div');
        wrap.parentNode.insertBefore(placeholder, wrap);
      }
      placeholder.style.cssText = 'height:' + bh + 'px;display:block;';
      /* z-index:40 keeps tab bar above page content but below the header (300)
         and below any mobile nav drawer the theme opens on hamburger tap */
      wrap.style.cssText = 'position:fixed!important;top:' + getNavH() + 'px!important;left:0!important;right:0!important;z-index:40!important;';
      startAlign();
    }
    function makeNormal() {
      if (!fixed) return;
      fixed = false;
      if (alignRaf) { cancelAnimationFrame(alignRaf); alignRaf = null; }
      if (placeholder) placeholder.style.cssText = 'height:0;display:none;';
      wrap.style.cssText = '';
    }
    function calcTop() {
      if (fixed) makeNormal();
      origTop = wrap.getBoundingClientRect().top + window.pageYOffset;
    }
    function onScroll() {
      if (window.pageYOffset >= origTop - getNavH()) makeFixed();
      else makeNormal();
      if (fixed) startAlign();
    }
    window.addEventListener('pll:headerResized', function () {
      if (fixed) wrap.style.top = getNavH() + 'px';
    });
    setTimeout(function () {
      calcTop();
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { makeNormal(); calcTop(); onScroll(); updateHints(); }, { passive: true });
    }, 150);

    /* ---- scroll active tab into view on load ---- */
    var active = bar.querySelector('.pll-tb-tab.active');
    if (active) requestAnimationFrame(function () {
      active.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
    });
  }

  function init() {
    document.querySelectorAll('[data-pll-tab-bar]').forEach(initTabBar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
